'use strict';

module.exports = function (el) {
    var children = [];

    for (var i = el.children.length; i--;) {
        // Skip comment nodes on IE8
        if (el.children[i].nodeType !== 8) {
            children.unshift(el.children[i]);
        }
    }

    return children;
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/utilities/children.js
// module id = 97
// module chunks = 0